<button
  [attr.type]="type()"
  [class]="btnClass()"
  [class.icon-only]="!label()"
  [disabled]="disabled() || loading()"
  (click)="handleClick($event)"
  [attr.aria-label]="ariaLabel() ?? label() ?? null"
  [attr.aria-busy]="loading() ? 'true' : null"
>
  @if (iconClass()) { @if (loading()) {
  <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
  } @else {
  <i [class]="iconClass()" aria-hidden="true"></i>
  } } @if (label()) { <span>{{ label() }}</span> }
</button>
